export type MemberInvoice = {
  balance: number;
  batchInvoiceId: number;
  dueDate: string;
  invoiceId: number;
  name: string;
  programId: number;
  programName: string;
  scheduledPaymentsAmount: number;
  seasonId: number;
  seasonName: string;
  status: string;
  total: number;
  divisionId: number;
};

export type MemberInvoiceDataResponse = {
  error: string | null;
  data: MemberInvoiceData[];
  status: number;
  time: string;
  metadata: any;
};

export type MemberInvoiceData = {
  balance: number;
  batch_invoice_id: number;
  due_date: string;
  id: number;
  name: string;
  program_id: number;
  program_name: string;
  scheduled_payments_amount: number;
  season_id: number;
  season_name: string;
  status: string;
  total: number;
  division_id: number;
};

export type MemberInvoicesKeyInsights = {
  overdueAmount: number;
  scheduleAmount: number;
  outstandingAmount: number;
  paidAmount: number;
};

export enum InvoiceStatus {
  SCHEDULED = 'scheduled_open',
  FAILED = 'failed_open',
  OPEN = 'open',
  PAID = 'paid',
  CANCELED = 'canceled',
  SUBMITTED = 'submitted',
}
